<template>
    <div class="onboarding">
        <div class="page container text-align-center">

            <div class="avatar" :style="{ backgroundImage: 'url(\'' + currentUser.photoURL + '\')' }"></div>
            
            <div v-if="!isMember">
                
                <h1>Hello {{ currentUser.displayName | getFirstName }}<br>Welcome to OneMgl</h1>
                <p class="desc">We welcome you to our members club. Looks like you are not our member yet. Our membership costs only {{ memberFee }} (One Time Fee) at the moment. Enjoy the community events ;)</p>

                <div class="paymentSection">

                    <h1>{{ memberFee }}</h1>
                    <a href="#0" class="btn green activateStripeBtn" v-show="!stripeCardActivate" @click.prevent="activateStripeCard">Pay by Card</a>
                    
                    <Payment
                        v-if="stripeCardActivate"
                        type="membership"
                        @paymentSuccess="paymentSuccess($event)"
                    ></Payment>

                    <div v-if="paySuccess" class="paymentSection">
                        <br/>
                        <router-link to="/events" class="btn green icon-right">Go to Events <ion-icon name="arrow-forward"></ion-icon></router-link>
                        <span>or</span>
                        <router-link to="/workshops" class="btn green icon-right">Go to Workshops <ion-icon name="arrow-forward"></ion-icon></router-link>
                    </div>
                </div>
            </div>
            <div v-else>

                <div v-show="!paySuccess">
                    <h1>Welcome back {{ userProfile.displayName | getFirstName }}</h1>
                    <p class="desc">It is very nice to see you again. We are really happy that you are our true member. Enjoy all of our events ;)</p>

                    <div class="paymentSection">
                        <br/>
                        <router-link to="/events" class="btn green icon-right">Go to Events <ion-icon name="arrow-forward"></ion-icon></router-link>
                        <span>or</span>
                        <router-link to="/workshops" class="btn green icon-right">Go to Workshops <ion-icon name="arrow-forward"></ion-icon></router-link>
                    </div>
                </div>
                <div v-show="paySuccess">
                    <h1>Payment Successfull</h1>
                    <p class="desc">The payment has been completed. We are really happy that you are our true member. Please join at least 1 free event now:</p>

                    <div class="paymentSection">
                        <br/>
                        <router-link to="events" class="btn green">Go to Events</router-link>
                    </div>
                </div>
            </div>
            
        </div>
        <svg class="item1" xmlns="http://www.w3.org/2000/svg" width="312" height="312" viewBox="0 0 312 312"><g transform="translate(-1608 -80)"><path d="M79.715,0A178.881,178.881,0,0,1,239.194,259.769a.751.751,0,0,0,0,.823H15.923s-1.123-.5-1.833-.823C3.342,256.957,1.435,249.375.045,244.272a8.742,8.742,0,0,1,0-1.645V19.615s-.052-.915,1.87-1.848A177.909,177.909,0,0,1,79.715,0Z" transform="translate(1920 340.592) rotate(180)" fill="#e5554a"/><circle cx="83.5" cy="83.5" r="83.5" transform="translate(1608 225)" fill="#67b6ea"/></g></svg>
        <svg class="item2" xmlns="http://www.w3.org/2000/svg" width="368.256" height="396.554" viewBox="0 0 368.256 396.554"><g transform="translate(0.256 -524)"><path d="M180.793,0C303.5,0,402.975,99.474,402.975,222.181a221.617,221.617,0,0,1-24.022,100.592.933.933,0,0,0,0,1.023H101.529s-1.4-.619-2.277-1.023C85.9,319.28,83.527,309.858,81.8,303.518a10.862,10.862,0,0,1,0-2.043V24.373s-.065-1.137,2.323-2.3A221.06,221.06,0,0,1,180.793,0Z" transform="translate(-82 596.758)" fill="#ffc107" opacity="0.698"/><circle cx="119" cy="119" r="119" transform="translate(130 524)" fill="#34aa59"/></g></svg>
    </div>
</template>

<script>
    const fb = require('../../firebaseConfig.js')
    import Payment from '../../components/Payment.vue'
    
    export default {
        components: {
            Payment
        },
        data(){
            return{
                memberFee: '$1',
                payAmount: '$1.00',
                stripeCardActivate: false,
                hidePayBtn: false,
                errorMsg: '',
                paySuccess: false,
                defaultPaymentMethod: null
            }
        },
        computed: {
            currentUser(){
                return this.$store.state.currentUser
            },
            userProfile(){
                return this.$store.state.userProfile
            },
            isMember(){
                return this.$store.state.isMember
            }
        },
        mounted(){
            if(this.$route.query.logout){
                this.logout()
            }
        },
        methods: {
            logout() {
                fb.auth.signOut().then(() => {
                    this.$store.dispatch('clearData')
                    this.$router.push('/home')
                }).catch(err => {
                    console.log(err)
                })
            },
            activateStripeCard(){
                this.stripeCardActivate = true
            },
            resetPurchase(){
                this.hidePayBtn = false
                this.errorMsg = ''
            },
            paymentSuccess(paymentId){

                self.hidePayBtn = true
                self.errorMsg = ''
                self.paySuccess = true
                self.defaultPaymentMethod = 'card'
                self.stripeCardActivate = false
                
                console.log('Payment successfull: ', paymentId)
            }
        },
        filters: {
            getFirstName(value){
                if(!value) return ''
                return value.split(' ').slice(0, -1).join(' ')
            }
        } 
    }
</script>


// WEBPACK FOOTER //
// src/views/Onboarding/Welcome1.vue